<template>
  <div>
	  <Header :sel='3' @changePhone="changePhone"/>
	  <!--neirong-->
	  <div :class="['cd-main-content',showPhone?'nav-is-visible':'']">
	   <div class="banner">
  </div>
  <!--banner--> 
  
  <!--neirong-->
   <div class="bread_bg"><div class="bread"> <a href="/">首页</a> - <a href="/#/caseList">案例推荐</a></div></div>
   <div class="neirong">
      <div class="anli_con">
      
      <div class="anli_con_l">
      <div class="case_biaoqian" style="padding-left:0"><span class="bq_red">{{ detail.clientName }}</span></div>
    <div class="fangan_title">{{detail.caseName}}</div>
    <div class="fangan_bq2">案例简介</div>
    <div class="fangan_jianjie">{{ detail.introduction }}</div>
    <div class="fangan_bq2">案例详情</div>
    <div class="fangan_jianjie" v-html="detail.detail"></div>
<div v-if="detail.link">
	<div class="fangan_bq2">案例链接</div>
	
	<div class="fangan_jianjie"><a href="javascript:void(0)" @click="goNext2(detail.link)">原文 | {{ detail.caseName }}</a></div>
	</div>
	</div>
      <div class="anli_con_r">
      <img :src="detail.image" />
        <div class="fangan_bq2">相关案例推荐</div>
           <ul class="anli_tuijian">
   <li v-for="(item,index) in solutionList" :key="index"><a href="javascript:void(0)" @click="goNext(item.id)">{{item.caseName}}</a></li>
     
   </ul>
      </div>
      </div>
    
     <div class="pages">
 <div class="pages_up" v-if="prevArticle" @click=goNext(prevArticle.id)>
 <p>上一篇</p>
 <p><a href="javascript:void(0)" >{{ prevArticle.caseName }}</a></p>
 </div>
  <div class="pages_next" v-if="nextArticle" @click=goNext(nextArticle.id)>
 <p>下一篇</p>
 <p><a href="javascript:void(0)" >{{ nextArticle.caseName }}</a></p>
 </div>
 </div>
  </div>
		 <Footer/>
		</div>
	  
	  
	  
	  <!--neirong--> 
	  
   
  </div>
</template>

<script>
	import Header from '@/components/header.vue'
	import Footer from '@/components/footer.vue'
	import{getCaseDetail,getCaseNextAndPrev,getCaseSolutionList} from '@/api/reqFetch.js'
	
  export default {
  	name: '',
    layout: '',
	components: {
	  Footer,
	  Header
	},
  	data() {
  		return {
			id:'',
			detail:{},
			showPhone:false,
            prevArticle:{},
            nextArticle:{},
            solutionList:[]
		}
  	},

  	mounted() {
		this.id=this.$route.query.id
       this.getCaseDetail();
       this.getCaseNextAndPrev();
        this.getCaseSolutionList()
  	},

  	methods: {
		goNext(id) {
			let url = '/caseDetail?id=' + id
			if (this.$route.fullPath != url) {
				this.$router.push(url)
				this.$router.go(0)
			}
		},
        goDetail(id){
            this.id = id
            this.getCaseDetail();
            this.getCaseNextAndPrev();
            this.getCaseSolutionList()
        },
		changePhone(val){
			this.showPhone=val
		},
        getCaseSolutionList(){
            getCaseSolutionList({
                id: this.id,
            }).then(res => {
                this.solutionList = res.data
            });
        },
		getCaseDetail(){
			getCaseDetail({
				id: this.id,
			}).then(res => {
				this.detail = res.data
                document.title = this.detail.caseName+ ' - ' + localStorage.getItem('webTitle')
			});
		},
        getCaseNextAndPrev(){
			getCaseNextAndPrev({
				id: this.id,
                categoryCode: '',
                moduleCode:''
			}).then(res => {
				this.prevArticle = res.data.prevArticle
                this.nextArticle = res.data.nextArticle

			});
		},
		goNext2(url){
			// 使用window.open在新窗口打开指定URL
			  window.open(url, '_blank');
		}
     
  	}
  }
</script>

<style scoped>/*内容*/
.banner{
	background-image: url('../../assets/images/banner_10.jpg');
	
}
ul.anli_tuijian li a {
	display: inline-block;border-bottom: 1px solid #eee; padding-top: 10px; padding-bottom: 10px;
}
</style>
